import { render, staticRenderFns } from "./matrixRadio.vue?vue&type=template&id=3cf2dcfa&scoped=true&"
import script from "./matrixRadio.vue?vue&type=script&lang=ts&"
export * from "./matrixRadio.vue?vue&type=script&lang=ts&"
import style0 from "./matrixRadio.vue?vue&type=style&index=0&id=3cf2dcfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf2dcfa",
  null
  
)

export default component.exports